import React, { Component } from 'react';
import ChangePassword from './../../modules/ChangePassword';
import {PATHS} from './../../../../constants/Define';

export default class UserProfile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
        }
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.userState && nextProps.userState.isFetching !== this.state.isFetching){
            this.setState({isFetching: nextProps.userState.isFetching});
            if(nextProps.userState.newPassword){
                this.gotoLogin();
            }
        }
    }

    gotoLogin = () => {
        this.props.history.push(PATHS.LOGIN.path)
    }

    onSave = (data) => {
        this.props.changePasswordUser({ oldPassword: data.current, newPassword: data.new })
    };

    render() {
        const { isFetching } = this.state;
        return (
            <ChangePassword loading={isFetching} onSave={this.onSave} />
        );
    }
}



